webpackJsonp([80860605978170],{

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cwr_group.188e6e34.jpg";

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cwr_group = __webpack_require__(153);
	
	var _cwr_group2 = _interopRequireDefault(_cwr_group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatementOfPurpose = function StatementOfPurpose() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'staticPage' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Statement of Purpose'
	        ),
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Our Purpose'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'To establish and operate Christian camps for young people in order to:'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Win them to Jesus Christ.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Mature those already Christian.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Show them you can be Christian and have fun.'
	            )
	        ),
	        _react2.default.createElement('img', { src: _cwr_group2.default }),
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Statement of Purpose and Mission'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'The purpose and mission of Youth Camps for Christ, Incorporated, shall be to glorify God through the provision of Christ-centered camping and conference ministries, whose aim shall be to lead others into a personal relationship with Jesus Christ and to provide opportunities for maturity and growth for those who are already in Christ. It shall be the ultimate goal of Youth Camps for Christ, Incorporated, to magnify the name of the Lord Jesus Christ that God may be glorified through His name.'
	        )
	    );
	};
	
	exports.default = StatementOfPurpose;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-statement-of-purpose-js-c87c7d6ebea50645bd4f.js